import CaseMonitors from './CaseMonitors.vue';

export default CaseMonitors;
